import React from "react";
import { IconProps } from "./Icon.types";
import Box from "../../primitives/Box/Box";
import { Caps2SemiboldTypography } from "../../primitives/Typography/typographyVariants";
import { IconWrapper } from "./Icon.styles";
import { colorGuide } from "../../theme/colors";

export const Icon = ({
  name,
  onClick,
  state = "default",
  count,
  notificationColor,
  countColor,
  countTextColor,
  top,
  right,
  bottom,
  left,
  ...props
}: IconProps) => {
  return (
    <IconWrapper onClick={onClick} {...props} data-cy={props.dataCy}>
      <i className={name}></i>
      {state === "notification" && (
        <Box
          backgroundColor={notificationColor}
          height="12px"
          width="12px"
          borderRadius="50%"
          px={4}
          py={5}
          border={`1px solid ${colorGuide.lightComponents.icon.borderColor}`}
          position="absolute"
          top="-4px"
          right="-4px"
        />
      )}
      {state === "count" && Number(count) > 0 && (
        <Box
          backgroundColor={countColor}
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="16px"
          width={Number(count) < 10 ? "16px" : undefined}
          minWidth="16px"
          px={Number(count) < 10 ? "2px" : "5px"}
          py="4px"
          borderRadius="8px"
          border="1px solid"
          borderColor="#e0e0e0"
          position="absolute"
          top={top || "-8px"}
          right={right || "-4px"}
          bottom={bottom || "auto"}
          left={left || "auto"}
          zIndex={10}
        >
          <Caps2SemiboldTypography color={countTextColor} letterSpacing="0px">
            {count}
          </Caps2SemiboldTypography>
        </Box>
      )}
    </IconWrapper>
  );
};
